import template from './adpChartLegend.html';
import controller from './adpChartLegend.controller';
import './adpChartLegend.less';

let adpChartLegendComponent = {
  restrict: 'E',
  bindings: {
  	itemList: '<'
  },
  template,
  controller
};

export default adpChartLegendComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpChartLegend/adpChartLegend.component.js